module.exports = __webpack_public_path__ + "lato-black-italic-798eafdd87dc8f3174f76164f0685e02.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-black-italic/lato-black-italic.woff
// module id = 1069
// module chunks = 0